import { FEEDBACK_METRIC_IDS } from "@domains/feedback/shared/feedbackTypes.ts";
import { z } from "zod";

export const FEEDBACK_REPORT_TYPES = ["Pulse", "Suggestion", "Smart", "Onboarding", "CustomQuestions"] as const;
export type FeedbackReportType = (typeof FEEDBACK_REPORT_TYPES)[number];

export const FEEDBACK_REPORT_SENTIMENTS = ["Positive", "Constructive", "Neutral"] as const;
export type FeedbackReportSentiment = (typeof FEEDBACK_REPORT_SENTIMENTS)[number];

export const FeedbackReportFiltersSchema = z.object({
    type: z.enum(FEEDBACK_REPORT_TYPES).nullable(),
    sentiment: z.enum(FEEDBACK_REPORT_SENTIMENTS).nullable(),
    metricId: z.enum(FEEDBACK_METRIC_IDS).nullable()
});
export type FeedbackReportFilters = z.infer<typeof FeedbackReportFiltersSchema>;
